import {

    FETCH_CUSTOMERS_PENDING,
    FETCH_CUSTOMERS_FULFILLED,
    FETCH_CUSTOMERS_REJECTED,

    FETCH_CUSTOMER_PENDING,
    FETCH_CUSTOMER_FULFILLED,
    FETCH_CUSTOMER_REJECTED,

    CREATE_CUSTOMER_PENDING,
    CREATE_CUSTOMER_FULFILLED,
    CREATE_CUSTOMER_REJECTED,

    UPDATE_CUSTOMER_PENDING,
    UPDATE_CUSTOMER_FULFILLED,
    UPDATE_CUSTOMER_REJECTED,

    DELETE_CUSTOMER_PENDING,
    DELETE_CUSTOMER_FULFILLED,
    DELETE_CUSTOMER_REJECTED,
    
    CHANGE_CUSTOMER,
    
    ADD_CUSTOMER

} from './customerActions'

const titleCase = (str) => {
    if (typeof str !== 'string') return str;
    return str.toLowerCase().split(' ').map(function(word) {
        return (word.charAt(0).toUpperCase() + word.slice(1));
    }).join(' ');
}

const initialState = {
    loading: false,
    listOfCustomers: [],
    customer: {
        codigo: 0,
        matriz: 0,
        status: 0,
        atividade: 0,
        razaoSocial: '',
        endereco: '',
        cep: '',
        bairro: '',
        complemento: '',
        estado: '',
        cidade: '',
        cpfCnpj: '',
        telefone: '',
        celular: '',
        nomeContato: '',
        celularContato: '',
        emailContato: '',
        emailsEventos: '',
        ramoAtividade: {
            codigo: 0,
            descricao: ''
        },
        clienteMatriz: {
            codigo: 0,
            razaoSocial: ''
        },
        pontoExcessoVelocidadeSeco: 0,
        pontoExcessoVelocidadeChuva: 0,
        pontoExcessoRPM: 0,
        pontoConducaoBanguela: 0,
        pontoFreadaBrusca: 0,
        pontoAceleracaoBruscaParado: 0,
        pontoAceleracaoBruscaMovimento: 0,
        pontoExcessoTemperatura: 0,
    },
    error: null,
}

export function customerReducer(state = initialState, action) {
    switch (action.type) {
        case CHANGE_CUSTOMER: 
            let value = ""
            
            if (action.payload.name.includes('mail')) {
                value = action.payload.value.toLowerCase();
            } else 
                if (action.payload.name.includes('apelido')) {
                    value = action.payload.value;
                } else {
                    value = titleCase(action.payload.value);
                }

            return Object.assign({}, state, {
                customer: { ...state.customer, 
                    [action.payload.name]: value
                }
            })
        case ADD_CUSTOMER: 
            return Object.assign({}, state, {
                customer: { ...initialState.customer }
            })
        case FETCH_CUSTOMERS_PENDING:
            return Object.assign({}, state, {
                loading: true,
                listOfCustomers: [],
            })
        case FETCH_CUSTOMERS_FULFILLED:
            return Object.assign({}, state, {
                loading: false,
                listOfCustomers: action.payload
            })
        case FETCH_CUSTOMERS_REJECTED:
            return Object.assign({}, state, {
                loading: false,
                error: action.payload
            })

        case CREATE_CUSTOMER_PENDING:
            return Object.assign({}, state, {
                loading: true,
                //customer: { ...initialState.customer },
            })
        case CREATE_CUSTOMER_FULFILLED:
            return Object.assign({}, state, {
                loading: false,
                customer: action.payload
            })
        case CREATE_CUSTOMER_REJECTED:
            return Object.assign({}, state, {
                loading: false,
                error: action.payload
            })

        case UPDATE_CUSTOMER_PENDING:
            return Object.assign({}, state, {
                loading: true,
            })
        case UPDATE_CUSTOMER_FULFILLED:
            return Object.assign({}, state, {
                loading: false,
                customer: action.payload
            })
        case UPDATE_CUSTOMER_REJECTED:
            return Object.assign({}, state, {
                loading: false,
                error: action.payload
            })

        case FETCH_CUSTOMER_PENDING:
            return Object.assign({}, state, {
                loading: true,
            })
        case FETCH_CUSTOMER_FULFILLED:
            return Object.assign({}, state, {
                loading: false,
                customer: action.payload
            })
        case FETCH_CUSTOMER_REJECTED:
            return Object.assign({}, state, {
                loading: false,
                error: action.payload
            })

        case DELETE_CUSTOMER_PENDING:
            return Object.assign({}, state, {
                loading: true,
            })
        case DELETE_CUSTOMER_FULFILLED:
            return Object.assign({}, state, {
                loading: false,
            })
        case DELETE_CUSTOMER_REJECTED:
            return Object.assign({}, state, {
                loading: false,
                error: action.payload
            })

        default:
            return state
    }
}